<template>
  <div class="pr-5 pl-5">
    <div v-if="StayNightInfo" id="shopcart_info">
      <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold cursorPointer"
            @click="$router.push('/index/index_homestay/homestay_detail/'+ ShopTargetInfo.homestayId)">
          {{ShopTargetInfo.homestayTitle}}</h4>
        <div id="empty_cart">
          <span class="text-muted">入住日期：</span><span
          class="text-blue">{{ShopTargetInfo.date_in | formatTimestamp()}}</span>
          <span class="text-muted ml-3">离店日期：</span><span
          class="text-blue">{{ShopTargetInfo.date_out | formatTimestamp()}}</span>
          <span class="ml-3">共{{(ShopTargetInfo.date_out - ShopTargetInfo.date_in)/86400}}晚</span>
          <el-button type="danger" size="small" class="ml-3" @click="clearShopCar">清空购物车</el-button>
        </div>
      </div>
      <div class="mt-3 text-left" v-if="ShopRoomArr.length > 0">
        <p class="mb-2">所选房间：</p>
        <div class="d-flex align-items-center mb-3 border rounded p-3" v-for="(roomItem,index) in ShopRoomArr"
             :key="roomItem.id">
          <img v-lazy="ImgPreUrl + roomItem.pic" height="80" width="80"/>
          <label class="ml-3 font-weight-bold">{{roomItem.roomTitle}}</label>
          <div class="ml-auto mr-5 d-flex align-items-center">
            <div class="mr-4 text-left">
              <p class="mb-0">单价：&yen; {{roomItem.noweekPrice}} / 间 <span class="text-muted">（非周末价）</span></p>
              <p class="mb-0">单价：&yen; {{roomItem.weekPrice}} / 间 <span class="text-muted">（周末价）</span></p>
            </div>
            <i class="iconfont text-blue" style="font-size: 16px;"
               @click="ctrlNum('room',-1,roomItem,index)">&#xe6f2;</i>
            <input type="number" class="product-num" v-model.number="ShopRoomArr[index].num"
                   @blur="submitNum('room',index,roomItem)">
            <i class="iconfont text-blue" style="font-size: 16px;"
               @click="ctrlNum('room',1,roomItem,index)">&#xe613;</i>
            <span class="ml-2 text-muted">（最大可供房：{{roomItem.roomTotalNums}}间）</span>
          </div>
          <span>总计：<span class="text-info">&yen; {{Number(roomItem.price).toFixed(2)}}</span></span>
          <el-popover placement="top" width="160" v-model="ShopRoomArr[index].deleteVisible">
            <p>确定将此项移出购物车么？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="canceldelete('room',index,roomItem,false)">取消</el-button>
              <el-button type="primary" size="mini" @click="sureDelete(roomItem)">确定</el-button>
            </div>
            <a href="javascript:;" class="ml-5" slot="reference"
               @click="canceldelete('room',index,roomItem,true)">删除</a>
          </el-popover>
        </div>
      </div>
      <div class="mt-5 text-left" v-if="ShopActisArr.length > 0">
        <p class="border-bottom">民宿活动：</p>
        <div class="d-flex align-items-center mb-3 border rounded p-3" v-for="(actiItem,index) in ShopActisArr"
             :key="index">
          <img v-lazy="ImgPreUrl + actiItem.pic" height="50" width="50"/>
          <label class="ml-3 font-weight-bold">{{actiItem.saleTitle}}</label>
          <div class="ml-auto mr-5">
            <span class="text-left" style="display: inline-block;width: 150px;">单价：&yen; {{actiItem.salePrice}} / {{actiItem.saleType==1?'场':'人'}}</span>
            <i class="iconfont text-blue" style="font-size: 16px;"
               @click="ctrlNum('acti',-1,actiItem,index)">&#xe6f2;</i>
            <input type="number" class="product-num" v-model.number="ShopActisArr[index].num"
                   @blur="submitNum('acti',index,actiItem)">
            <i class="iconfont text-blue" style="font-size: 16px;"
               @click="ctrlNum('acti',1,actiItem,index)">&#xe613;</i>
          </div>
          <span>总计：<span class="text-info">&yen; {{actiItem.price.toFixed(2)}}</span></span>
          <el-popover placement="top" width="160" v-model="ShopActisArr[index].deleteVisible">
            <p>确定将此项移出购物车么？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="canceldelete('acti',index,actiItem,false)">取消</el-button>
              <el-button type="primary" size="mini" @click="sureDelete(actiItem)">确定</el-button>
            </div>
            <a href="javascript:;" class="ml-5" slot="reference"
               @click="canceldelete('acti',index,actiItem,true)">删除</a>
          </el-popover>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <label class="text-muted">入住人姓名：</label>
        <input type="text" class="form-control mr-3" style="width: 120px;" v-model="occupant_name">
        <label class="text-muted ml-3">联系方式：</label>
        <input type="number" @mousewheel.native.prevent class="form-control mr-3" style="width: 120px;" v-model="occupant_mobile">
      </div>
      <div class="text-left mt-4">
        <p class="text-muted mb-1">需求说明：</p>
        <textarea class="form-control" v-model="remarksInfo"></textarea>
      </div>
      <div class="text-left mt-4">
        <p class="text-muted mb-1">单位信息：</p>
        <div class="border rounded d-flex justify-content-between p-3">
          <div class="w-50">
            <div class="d-flex align-items-center mb-3">
              <div class="form-left-text">单位名称</div>
              ：{{ShopTravelInfo.title}}
            </div>
            <div class="d-flex align-items-center">
              <div class="form-left-text">办公室电话</div>
              ：{{ShopTravelInfo.telephone}}
            </div>
          </div>
          <div class="w-50">
            <div class="d-flex align-items-center mb-3">
              <div class="form-left-text">联系人姓名</div>
              ：{{ShopTravelInfo.truename}}
            </div>
            <div class="d-flex align-items-center">
              <div class="form-left-text">联系人电话</div>
              ：{{ShopTravelInfo.mobile}}
            </div>
          </div>
        </div>
      </div>
      <el-button type="primary" class="mt-5 mb-5" style="width: 200px;" @click="submitShopCar">提交订单</el-button>
    </div>
    <div class="d-flex align-items-center justify-content-center flex-column" v-else style="min-height: 500px;">
      <i class="iconfont" style="font-size: 30px;">&#xe660;</i>
      <span>购物车空空如也，快去 <router-link to="/index/index_homestay">添加</router-link> 吧</span>
    </div>
    <el-dialog title="请选择集团门店" :visible.sync="showChildren" width="70%" center :modal-append-to-body='false'>
      <el-radio-group v-model="radio" class="w-100">
        <el-radio :label="item.store_id" :key="item.store_id" class="w-50 ml-0 mb-4 mr-0"
           v-for="item in StoreLists.lists" :disabled="item.verify != 1">
          {{item.title}}
          <span v-show="item.verify != 1">({{item.verify | formatVar('verifyType')}})</span>
        </el-radio>
      </el-radio-group>
      <el-pagination background layout="prev, pager, next" class="mt-4 mb-4 text-center"
          :total="StoreLists.total" :current-page=page
          @current-change="v => {page=v;TraGroupGetStoreLists({ page:v, url })}"/>
      <el-button class="m-auto block" type="primary" @click="enSure">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    name: 'SubmitOrder',
    data() {
      return {
        occupant_name: '',              //入住人姓名
        occupant_mobile: '',            //入住人联系方式
        remarksInfo: '',                //需求说明
        page: 1,
        radio: '',
        showChildren: false,
        url: 'pc/Travel/getStoreMaterial'
      }
    },
    computed: {
      ...mapState(['ShopTargetInfo', 'ShopRoomArr', 'ShopActisArr', 'ShopTravelInfo', 'StayNightInfo', 'userLoginMessage', 'ShopNewPrice','StoreLists']),
      ...mapGetters(['isGroup','storeInfo'])
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({ storeId: '' })
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['EmptyShopCart', 'GetShopCartInfo', 'EditShopNum', 'DeleteShopCart', 'SubmitShopCart','TraGroupGetStoreLists']),
      enSure () {
        if (!this.radio) { this.$message.warning('请选择子门店！'); return }
        this.UPDATECURRENTSTORE({storeId:this.radio});
        this.submitShopCar()
        this.showChildren = false;
      },
      //是否确认清空购物车弹框
      clearShopCar() {
        this._confirm('是否确认清空购物车？', this.confirmedClear, 'warning');
      },
      //确认清空购物车
      confirmedClear() {
        let dataArr = this.ShopRoomArr.concat(this.ShopActisArr);
        let idArr = dataArr.map(item => item.id);
        let shopcartId = idArr.join(',');
        this.EmptyShopCart({
          shopcartId,
          successFun: () => {
            this.GetShopCartInfo({
              type: '5'
            })
          }
        })
      },
      //计算购物车数量
      ctrlNum(type, ctrl, item, index) {
        //只有民宿活动才有lessNum值，房型的该字段统一赋值为1
        if (type === 'room') item.lessNum = 1;
        else if (type === 'acti') item.lessNum = item.lessNum <= 0 ? 1 : '';
        if (item.num + ctrl < item.lessNum) {
          this.$alert('数量最小不得少于' + item.lessNum, '提示', {
            confirmButtonText: '确定',
            center: true
          });
        } else if (item.saleType == 2 && item.num + ctrl > item.maxNum) {
          this.$alert('数量最大不得超过' + item.maxNum, '提示', {
            confirmButtonText: '确定',
            center: true
          });
        } else {
          item.num = item.num + ctrl;
          if (type === 'room') this.$set(this.ShopRoomArr, index, item);
          else if (type === 'acti') this.$set(this.ShopActisArr, index, item);
          //设置截流函数，防止用户快速点击+和-时频繁提交数据到后台
          (() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.submitNum(type, index, item);
            }, 500)
          })();
        }
      },
      //提交修改后的购物车数量
      async submitNum(type, index, item) {
        item.price = await this.EditShopNum({
          shopcartId: item.id,
          num: item.num
        });
        if (type === 'room') this.$set(this.ShopRoomArr, index, item);
        else if (type === 'acti') this.$set(this.ShopActisArr, index, item);
      },
      //取消删除购物车条目
      canceldelete(type, index, actiItem, bool) {
        actiItem.deleteVisible = bool;
        if (type === 'room') this.$set(this.ShopRoomArr, index, actiItem);
        else if (type === 'acti') this.$set(this.ShopActisArr, index, actiItem);
      },
      //确认删除该购物车条目
      sureDelete(item) {
        this.DeleteShopCart({
          shopcartId: item.id,
          successFun: () => {
            this.GetShopCartInfo({
              type: '5'
            })
          }
        })
      },
      //是否确认提交
      submitShopCar() {
        if (!this.$GFUN.powerIsInArray([227])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (this.isGroup && !this.showChildren && !this.radio) { this.TraGroupGetStoreLists({ url: this.url, data: {page:1} }); this.showChildren = true; return }
        this._confirm('订单提交后不可撤销和修改，确认提交么？', this.confirmedSubmit, 'warning');
      },
      //提交购物车表单
      confirmedSubmit() {
        this.SubmitShopCart({
          data: {
            store_id: this.storeInfo.storeId,
            occupant_mobile: this.occupant_mobile,
            occupant_name: this.occupant_name,
            remark: this.remarksInfo
          },
          successFun: () => {
            this._alert('提交成功',() => {
              this.$router.push({name:'OrderLists',query:{orderStatus:'14',orderType:5}})
            })
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  h4.cursorPointer:hover {
    color: #5ea9dd;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>
